
angular.module('ui.loading', ['templates']);
